import { TrainingStatus } from '../shared/constants';
import { ITraining } from '../types/interfaces/training';
import {
  ApiResponseCache,
  getStartedTrainingCacheKey,
} from './api-response-cache';

export function snapshotStartedTrainingIfNeeded(training: ITraining): void {
  if (training.status === TrainingStatus.started && training.id) {
    ApiResponseCache.set(getStartedTrainingCacheKey(training.id), training);
  }
}

export function removeStartedTrainingCache(trainingId: string): void {
  ApiResponseCache.remove(getStartedTrainingCacheKey(trainingId));
}

export function syncStartedTrainingSnapshotFromTraining(
  training: ITraining | undefined,
): void {
  if (!training?.id) {
    return;
  }
  if (training.status === TrainingStatus.started) {
    snapshotStartedTrainingIfNeeded(training);
  } else {
    removeStartedTrainingCache(training.id);
  }
}
